import script from "./BackgroundSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundSelector.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundSelector.vue?vue&type=style&index=0&id=0f7d5c7a&lang=css"

const __exports__ = script;

export default __exports__